import React from "react";

import { Typography } from "@material-ui/core";

import {
  AddIcon,
  InventoryMapIcon,
  RemoveIcon,
} from "../../../components/common/iconography";

export const InventorySetupHelp = ({ classes }) => (
  <>
    <Typography variant="subtitle1">
      <strong>Inventory Setup</strong>
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Qty. Advised & Received:</strong> Intital inventory stock.
          Both should be equal if no issues with Inbound Shipment. Displayed in
          a side bar once the inventory has been Stored.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. On Hand:</strong> Stock quantity on hand
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. Physical:</strong> Stock quantity as counted during an
          Inventory Audit. Should equal Qty. On Hand if physical count is
          accurate. This field is hidden unless there is a count mismatch.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. Available:</strong> Qty On Hand minus Qty. Committed
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Qty. Committed:</strong> Stock quantity Reserved for "Pending"
          Outbound Shipments
        </Typography>
      </li>
      <li>
        <Typography>
          <InventoryMapIcon className={classes.icon} />
          <strong> INVENTORY MAP: </strong>
          Opens Inventory Map dialog. Allows to inspect inventory distribution
          in the yard for a given account and to select a new location.
        </Typography>
      </li>
    </ul>
  </>
);

export const NotesHelp = ({ classes }) => (
  <>
    <Typography variant="subtitle1">
      <strong>Notes</strong>
    </Typography>
    <Typography variant="subtitle1">
      Use the Notes Tab to manually document key events and changes made to the
      Shipment record.
    </Typography>
    <ul>
      <li>
        <Typography>
          <AddIcon className={classes.icon} />
          <strong> ADD: </strong>Add new Note Line Item.
        </Typography>
      </li>
      <li>
        <Typography>
          <RemoveIcon className={classes.icon} />
          <strong> REMOVE: </strong>
          Remove selected Note Line Item - this info will be permanently lost.
        </Typography>
      </li>
    </ul>
  </>
);

export const HistoryHelp = ({ classes }) => (
  <>
    <Typography variant="subtitle1">
      <strong>History</strong>
    </Typography>
    <Typography variant="subtitle1">
      The History Tab provides an automated, chronological Audit Trail of key
      events and record changes.
    </Typography>
  </>
);
